import React from 'react';

const VideoRedaction = () => <div>Video Redaction Page</div>

export default VideoRedaction;